import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from "@angular/router";

@Injectable()
export class ApiService {
    constructor(
        private http: Http,
        private router: Router
    ) {
    }

    private setHeaders(): Headers {
        const headersConfig = {
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + localStorage.getItem('token')
        };
        return new Headers(headersConfig);
    }

    private fileUploadHeaders(): Headers {
        const headersConfig = {
            'Authorization': 'bearer ' + localStorage.getItem('token')
        };
        return new Headers(headersConfig);
    }

    private formatErrors(error: any) {
        return Observable.throw(error.json());
    }

    get(path: string, params: URLSearchParams = new URLSearchParams()): Observable<any> {
        return this.http.get(`${environment.client_url}${path}`, {headers: this.setHeaders(), search: params})
            .map((res: Response) => {
                return this.onResponseReceived(res.json());
            })
            .catch((error: any) => {
                return this.onErrorStatusReceived(error);
            })
            .finally(() => {
                this.onRequestEnded();
            });
    }

    put(path: string, body: Object = {}): Observable<any> {
        return this.http.put(`${environment.client_url}${path}`, JSON.stringify(body), {
            headers: this.setHeaders(),
            withCredentials: true
        })
            .catch((error: any) => {
                return this.onErrorStatusReceived(error);
            })
            .map((res: Response) => {
                return this.onResponseReceived(res.json());
            })
            .finally(() => {
                this.onRequestEnded();
            });
    }

    post(path: string, body: Object = {}): Observable<any> {
        return this.http.post(`${environment.client_url}${path}`, JSON.stringify(body), {headers: this.setHeaders()})
            .catch((error: any) => {
                return this.onErrorStatusReceived(error);
            })
            .map((res: Response) => {
                return this.onResponseReceived(res.json());
            });
    }

    upload ( path: string, body: FormData ): Observable<any> {

        return this.http.post( `${ environment.client_url }${ path }`, body, { headers: this.fileUploadHeaders() } )
        .catch((error: any) => {
            return this.onErrorStatusReceived(error);
        })
        .map((res: Response) => {
            return this.onResponseReceived(res.json());
        });
    }

    postApi(path: string, body: Object = {}): Observable<any> {
        return this.http.post(`${environment.api_url}${path}`, JSON.stringify(body), {headers: this.setHeaders()})
            .catch((error: any) => {
                return this.onErrorStatusReceived(error);
            })
            .map((res: Response) => {
                return this.onResponseReceived(res.json());
            });
    }

    onRequestStarted(): void {
        // console.log('this.onRequestStarted()');
    }

    onRequestSuccess(): void {
        // console.log('this.onRequestSuccess()');
    }

    onRequestFailed(): void {
        // console.log('this.onRequestFailed()');
    }

    onRequestEnded(): void {
        // console.log('this.onRequestEnded()');
    }

    private onResponseReceived(json: any) {

        if (json['inActive'] == true) {
            this.router.navigateByUrl('/access-denied?logout');
        }
        if (json['access'] == false) {

            this.router.navigate(['/access-denied']);
        } else {
            return json;
        }
    }

    private onErrorStatusReceived(error: any) {

        const currentUrl = this.router.url;
        if (currentUrl.startsWith('/invites/') || currentUrl.startsWith('/candidate/consent/')) {
            // stay on same page
        }
        else {
            if (error.status === 500 || error.status == 401 || error.status == 422) {
                return this.router.navigateByUrl('/login');
            }
            else {
                this.formatErrors(error);
            }
        }

    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/api.service.ts